import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../index';
import SimpleReactValidator from 'simple-react-validator';
import ContactFromEvent from './googleEvent'

const content = {
    en: {
        requestVisit: "E-mail us",
        name: "Name",
        email: "Email",
        message: "Message",
        send: "Send",
        contact: "contact",
    },
    pl: {
        requestVisit: "Napisz do nas",
        name: "Imię",
        email: "Email",
        message: "Wiadomość",
        send: "Wyślij",
        contact: "kontakt",
    }
};

const ContactForm = () => {
    const { language } = useContext(LanguageContext); // Access the current language
    const t = content[language]; // Get translations for the current language

    const [forms, setForms] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const [result, setResult] = useState(null);
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value });
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async e => {
        e.preventDefault();
        console.log("SUBMIT!");
        if (validator.allValid()) {
            validator.hideMessages();
            try {
                const response = await fetch('/send-email.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(forms),
                });

                const result = await response.json();
                setResult('success');
                console.log('Post result:', result);
            } catch (error) {
                setResult('error');
                console.error('An error occurred:', error.message);
                // alert('An error occurred: ' + error.message);
            }
            setForms({
                name: '',
                email: '',
                message: ''
            });
        } else {
            validator.showMessages();
        }
    };

    return (
        <form onSubmit={(e) => submitHandler(e)}>
            <div className="section-title text-center mb-40">
                <h2>{t.requestVisit}</h2>
            </div>
            <div className="row clearfix">
                <div className="col-md-12">
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder={t.name} />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder={t.email}
                            />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <textarea
                            className='form-control'
                            rows="10"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.message}
                            type="text"
                            name="message"
                            placeholder={t.message}
                            >
                        </textarea>
                        {validator.message('message', forms.message, 'required')}
                    </div>
                </div>
                {result === 'success' && (
                    <div className="col-md-12">
                        <div className="alert alert-success" role="alert">
                            <script>
                                fbq('track', 'Contact');
                            </script>
                            
                            {/* <script>
                                gtag('event', 'conversion', {'send_to': 'AW-11159481698/S_mICIjTqYsbEOLaoMkp'});
                            </script> */}
                            {language === 'pl' ? 'Wiadomość została wysłana pomyślnie!' : 'Message sent successfully!'}
                            <ContactFromEvent/>
                        </div>
                    </div>
                )}
                {result === 'error' && (
                    <div className="col-md-12">
                        <div className="alert alert-danger" role="alert">
                            {language === 'pl' ? 'Wystąpił błąd podczas wysyłania wiadomości.' : 'An error occurred while sending the message.'}
                        </div>
                    </div>
                )}
                <div className="col-md-12">
                    <button type="submit" className="theme-btn mt-40">{t.send}</button>
                </div>
            </div>
            <div className="title-rotated">{t.contact}</div>
        </form>
    );
};

export default ContactForm;